import {COUNTRY_CODES} from './constants/globalConstants';

export const showGtinFeature = (countryCode) => {
  const allowedMarkets = [COUNTRY_CODES.MEXICO];
  const isGtinEnabled = allowedMarkets.includes(countryCode);

  return isGtinEnabled;
};

export const showTierConfigurationsFeature = (countryCode) => {
  const allowedMarkets = [
    COUNTRY_CODES.MEXICO,
    COUNTRY_CODES.PERU,
    COUNTRY_CODES.ECUADOR
  ];
  return allowedMarkets.includes(countryCode);
};
